// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventDetailGetBody = {
  eventId: string;
  timeZone: string;
};

export type typeEventDetailGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    eventId: string;
    leagueId: string;
    seasonId: string;
    kickoffAt: string;
    status:
      | "scheduled"
      | "inProgress"
      | "final"
      | "postponed"
      | "canceled"
      | "delayed";
    statusLabel: string;
    statusDetail?: string | null;
    isLive: boolean;
    isKickoffPassed: boolean;
    winnerTeamId?: string | null;
    isTie: boolean;
    home: {
      teamId: string;
      name: string;
      abbreviation: string;
      logoMediaId?: string | null;
      primaryColorHex?: string | null;
      score?: number | null;
      recordLabel?: string | null;
      logoUrl?: string | null;
      shortName?: string | null;
    };
    away: {
      teamId: string;
      name: string;
      abbreviation: string;
      logoMediaId?: string | null;
      primaryColorHex?: string | null;
      score?: number | null;
      recordLabel?: string | null;
      logoUrl?: string | null;
      shortName?: string | null;
    };
    layout: "twoTeam" | "leaderboard";
    showCountdown: boolean;
    tabs: { key: string; label: string }[];
    matchup?: {
      sections: {
        key: string;
        title: string;
        rows: {
          key: string;
          label: string;
          awayValue: string;
          homeValue: string;
        }[];
        kind?:
          | "rows"
          | "lineScore"
          | "leaders"
          | "statComparison"
          | "scoringSummary"
          | "details"
          | "headToHead"
          | "lastFive"
          | "pitchers";
        lineScore?: {
          periods: {
            key: string;
            label: string;
            awayValue?: string | null;
            homeValue?: string | null;
          }[];
          totals: {
            key: string;
            label: string;
            awayValue?: string | null;
            homeValue?: string | null;
          }[];
          winnerSide?: "away" | "home" | null;
        } | null;
        leaders?: {
          categories: {
            key: string;
            title: string;
            columns: string[];
            away?: {
              name: string;
              jerseyNumber?: string | null;
              headshotUrl?: string | null;
              values: string[];
              playerId?: string | null;
            } | null;
            home?: {
              name: string;
              jerseyNumber?: string | null;
              headshotUrl?: string | null;
              values: string[];
              playerId?: string | null;
            } | null;
          }[];
        } | null;
        statComparison?: {
          rows: {
            key: string;
            label: string;
            awayValue: string;
            homeValue: string;
            awaySharePercent?: number | null;
            leader?: "away" | "home" | "even" | null;
            awayRankLabel?: string | null;
            homeRankLabel?: string | null;
          }[];
        } | null;
        details?: {
          rows: { key: string; label: string; value: string }[];
        } | null;
        headToHead?: {
          meetings: {
            key: string;
            dateLabel: string;
            awayAbbreviation: string;
            awayScore: number;
            homeAbbreviation: string;
            homeScore: number;
            winnerSide: "away" | "home" | "tie";
          }[];
        } | null;
        lastFive?: {
          away: {
            key: string;
            resultCode: "W" | "L" | "T";
            opponentLabel: string;
            scoreLabel: string;
            dateLabel: string;
          }[];
          home: {
            key: string;
            resultCode: "W" | "L" | "T";
            opponentLabel: string;
            scoreLabel: string;
            dateLabel: string;
          }[];
        } | null;
        scoringSummary?: {
          entries: {
            key: string;
            periodLabel: string;
            clockLabel: string;
            teamAbbreviation: string;
            description: string;
            awayScore: number;
            homeScore: number;
          }[];
        } | null;
        pitchers?: {
          phase: "starting" | "current" | "decisions";
          rows: {
            key: string;
            side: "away" | "home";
            name?: string | null;
            playerId?: string | null;
            decisionTag?: "W" | "L" | "S" | null;
            recordLabel?: string | null;
            lineLabel?: string | null;
          }[];
        } | null;
      }[];
    } | null;
    summary?: {
      entries: {
        key: string;
        periodLabel: string;
        clockLabel: string;
        teamAbbreviation: string;
        description: string;
        awayScore: number;
        homeScore: number;
      }[];
    } | null;
    statusHistory: {
      fromStatus?:
        | "scheduled"
        | "inProgress"
        | "final"
        | "postponed"
        | "canceled"
        | "delayed"
        | null;
      toStatus:
        | "scheduled"
        | "inProgress"
        | "final"
        | "postponed"
        | "canceled"
        | "delayed";
      kickoffAt: string;
      occurredAt: string;
    }[];
    refreshAfterSeconds: number;
    odds?: {
      spread?: {
        favoriteTeamId?: string | null;
        points?: number | null;
        isLocked: boolean;
        label: string;
        homeOdds: number | null;
        awayOdds: number | null;
        result: "home" | "away" | "push" | null;
      } | null;
      moneyline?: {
        homeOdds?: number | null;
        awayOdds?: number | null;
        result: "home" | "away" | "push" | null;
      } | null;
      total?: {
        points?: number | null;
        overOdds: number | null;
        underOdds: number | null;
        result: "over" | "under" | "push" | null;
      } | null;
    } | null;
    liveState?: {
      possessionTeamId?: string | null;
      baseball?: {
        balls: number;
        strikes: number;
        outs: number;
        isFirstOccupied: boolean;
        isSecondOccupied: boolean;
        isThirdOccupied: boolean;
        countLabel: string;
        outsLabel: string;
        pitcher?: { name: string; lineLabel: string | null } | null;
        batter?: { name: string; lineLabel: string | null } | null;
      } | null;
      football?: {
        ballSpotLabel: string;
        ballSpotPercentFromAway: number;
        firstDownPercentFromAway?: number | null;
        driveStartPercentFromAway?: number | null;
        driveSummaryLabel?: string | null;
      } | null;
      summaryLabel: string;
      downAndDistanceLabel?: string | null;
      hockey?: { powerPlayTeamId: string; powerPlayLabel: string } | null;
    } | null;
    lastPlay?: {
      entryId: string;
      description: string;
      periodLabel?: string | null;
      clockLabel?: string | null;
      teamId?: string | null;
      isScoringPlay: boolean;
      awayScore?: number | null;
      homeScore?: number | null;
    } | null;
  };
};

export type typeEventDetailGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventDetailGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventDetailGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventDetailGetBody = {
  type: "object",
  properties: {
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    timeZone: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["eventId", "timeZone"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventDetailGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventDetailGetBody);
  }

  return async function postEventDetailGet(
    payload: typeEventDetailGetBody,
  ): Promise<typeEventDetailGetOutput200 | typeEventDetailGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventDetailGet" failed before calling the network. #fd1a0cf0cee0`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#fd1a0cf0cee0" },
        },
        data: null,
      } as typeEventDetailGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/detail-get`,
      httpMethod: "POST",
      options,
    })) as typeEventDetailGetOutput200 | typeEventDetailGetOutput400;
  };
}
